import { render, staticRenderFns } from "./IPDActions.vue?vue&type=template&id=f91acd3e&"
import script from "./IPDActions.vue?vue&type=script&lang=js&"
export * from "./IPDActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports